/** SHEIN API 响应解析（兼容多种 info 结构） */

const LIST_KEYS = [
  'returnOrderList',
  'orderList',
  'list',
  'data',
  'records',
  'items',
  'rows',
  'certificateList',
  'agencyList',
  'skcAgencyList',
  'checkOrderList',
  'reportOrderList',
  'reportOrderInfos',
  'billList',
];

export function extractSheinList(payload) {
  if (!payload) return [];
  if (Array.isArray(payload)) return payload;

  for (const key of LIST_KEYS) {
    const val = payload[key];
    if (Array.isArray(val)) return val;
  }

  if (payload.info && typeof payload.info === 'object') {
    return extractSheinList(payload.info);
  }

  return [];
}

export function extractSheinTotal(payload, fallbackLength = 0) {
  if (!payload || typeof payload !== 'object') return fallbackLength;
  const candidates = [
    payload.total,
    payload.totalCount,
    payload.count,
    payload.totalNum,
    payload.totalRecords,
  ];
  for (const n of candidates) {
    const parsed = Number(n);
    if (Number.isFinite(parsed) && parsed >= 0) return parsed;
  }
  return fallbackLength;
}

export function pickField(row, ...keys) {
  if (!row || typeof row !== 'object') return '';
  for (const key of keys) {
    const val = row[key];
    if (val !== undefined && val !== null && String(val).trim() !== '') {
      return val;
    }
  }
  return '';
}

export function formatSheinCell(value) {
  if (value === undefined || value === null || value === '') return '—';
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
}
